import React from 'react';
import { Switch, FormControlLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

/**
 * A compact toggle that matches the SwitchInput visual design (Switch.js)
 * but is scaled to 70% for use in dense layouts like vendor cards.
 *
 * Props:
 *   checked       {boolean}  - controlled checked state
 *   onChange      {Function} - change handler (event) => void
 *   label         {string}   - label text rendered below the toggle
 *   labelStyle    {object}   - optional inline style overrides for the label
 *   disabled      {boolean}  - disables the control
 */

const StyledSwitchCompact = withStyles({
    root: {
        width: 39,
        height: 22,
        padding: 0,
    },
    switchBase: {
        padding: 3,
        '&$checked': {
            transform: 'translateX(17px)',
            color: '#fff',
            '& + $track': {
                backgroundColor: '#3C66C4',
                opacity: 1,
                border: 'none',
            },
        },
    },
    thumb: {
        width: 16,
        height: 16,
    },
    track: {
        borderRadius: 11,
        backgroundColor: '#bdbdbd',
        opacity: 1,
    },
    checked: {},
})(Switch);

export const SwitchCompact = ({ checked, onChange, label, labelStyle, disabled }) => {
    return (
        <FormControlLabel
            control={
                <StyledSwitchCompact
                    checked={!!checked}
                    onChange={onChange}
                    disabled={disabled}
                />
            }
            label={
                label !== undefined ? (
                    <span style={{ fontSize: '0.7rem', color: checked ? '#3C66C4' : '#9e9e9e', ...labelStyle }}>
                        {label}
                    </span>
                ) : null
            }
            labelPlacement="bottom"
            style={{ margin: 0 }}
        />
    );
};
